import { Flags, ValueOfKey } from '../../utils-types';
import { Option } from '../../general-types';

export const BILLING_PERIOD_TYPE = {
  MONTHLY: 'MONTHLY',
  DAILY: 'DAILY',
} as const;

export type BillingPeriodType = ValueOfKey<typeof BILLING_PERIOD_TYPE>;

export type BillingPeriodTypeFlags = Flags<BillingPeriodType>;

// use getHumanizeBillingPeriodType utils to get showed name
export const humanizeBillingPeriodType: Record<BillingPeriodType, string> = {
  MONTHLY: 'Monthly',
  DAILY: 'One-Time Payment',
};

export const billingPeriodTypeOptionsWithAll: Option<BillingPeriodType | ''>[] = [
  { label: 'All Subscriptions', value: '' },
  ...Object.values(BILLING_PERIOD_TYPE).map((type) => ({
    label: humanizeBillingPeriodType[type],
    value: type,
  })),
];
